import {createAsyncThunk, createSlice, PayloadAction} from '@reduxjs/toolkit'
import {http} from 'hiya-common/src/utils/axios'
import {useSelector} from 'react-redux'

export enum Status {
  成功 = 1,
  余额不足 = 2,
}

// 【神秘人套餐主页】http://wiki.xunlei.cn/pages/viewpage.action?pageId=136004643
export const mystery_homepage = createAsyncThunk(
  '/live/aristocracy/mystery_homepage',
  async (arg: any, store: any) => {
    const resp = await http.post<HiyaRes<InitialStateType>>(
      '/live/aristocracy/mystery_homepage',
      {
        ...store.getState().env.deviceinfo,
        ...arg,
      }
    )
    return resp.data.data
  }
)
// 【购买神秘人】 http://wiki.xunlei.cn/pages/viewpage.action?pageId=136004152
export const mystery_buy = createAsyncThunk(
  '/live/aristocracy/mystery_buy',
  async (arg: any, store: any) => {
    const resp = await http.post<any>('/live/aristocracy/mystery_buy', {
      ...store.getState().env.deviceinfo,
      ...arg,
    })
    return resp.data.data
  }
)

// [神秘人获得记录] http://wiki.xunlei.cn/pages/viewpage.action?pageId=136005402
export const mystery_get_record = createAsyncThunk(
  '/live/aristocracy/mystery_get_record',
  async (arg: any, store: any) => {
    const resp = await http.post<HiyaRes<{list: InitialStateType['records']}>>(
      'live/aristocracy/mystery_get_record',
      {
        ...store.getState().env.deviceinfo,
        ...arg,
      }
    )
    return resp.data.data
  }
)

export interface InitialStateType {
  homepage?: {
    video_url?: string
    free_msg?: string // 购买按钮上方的文案
    jump_url?: string // 免费文案对应的跳转链接
    price?: number
    days?: number
  }
  records: {
    desc?: string
    active_time?: string
    expire?: string
    icon?: string
  }[]
}

const initialState: InitialStateType = {
  homepage: {},
  records: [],
}

export const VipMIBSlice = createSlice({
  name: 'VipMIBSlice',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(mystery_homepage.fulfilled, (state, action) => {
      Object.assign(state.homepage, action.payload)
    })
    builder.addCase(mystery_get_record.fulfilled, (state, action) => {
      Object.assign(state.records, action.payload?.list)
    })
  },
})
export default VipMIBSlice.reducer
export const VipMIBActions = VipMIBSlice.actions

export const useVipMIBtate = () => {
  const data = useSelector((state) => {
    return state.VipMIB
  })
  return data
}
